import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from 'src/app/modules/shared/state/signal-entity.store';
import {Item} from 'src/app/modules/shared/models/policy.model';

export interface ItemState extends EntityState<Item> {}


@Injectable({providedIn: 'root'})
export class ItemStore extends SignalEntityStore<Item, ItemState> {
    constructor() {
        // Akita name was 'items', clashing with the question-flow ItemsStore;
        // renamed for a distinct localStorage key (transient data, no seed loss).
        super({name: 'claim-items', idKey: 'id'});
    }
}
